module.exports = __webpack_public_path__ + "static/media/LTE.f72517d6.png";